module.exports = __webpack_public_path__ + "static/media/CentraNo2-Bold.182cc5c0.woff";